import fontsData from '../data/fonts.json';
import {ConfigDispatch} from "../context/ConfigContext";
import {useContext} from "react";
import {ModalDispatch} from "../context/ModalContext";

function FontSelector({modal}) {
    const dispatch = useContext(ConfigDispatch);
    const modalDispatch = useContext(ModalDispatch);
    const handleClick = (e) => {
        dispatch({
            type: 'changeFontFamily',
            payload: e.target.style.fontFamily
        });
        modalDispatch({
            type: 'hideModal'
        });
    }

    const fontsList = fontsData.fonts.map(font => {
        return (
            <button
                className="fonts-selector__font"
                key={font.name}
                style={{fontFamily: "Monserrat, sans-serif"}}
                onClick={handleClick}
                aria-label={`Wybierz czcionkę ${font.name}`}
                type="button"
            >
                {font.name}
            </button>
        )
    });

    return (
        <div className="fonts-selector" role="list" aria-label="Lista czcionek">
            {fontsList}
        </div>
    )
}

export default FontSelector;
